import React, { useEffect, useState } from 'react';

interface MainContentProps {
  name: string;
  year: string;
  onNavigate: (section: string) => void;
}

const MainContent: React.FC<MainContentProps> = ({ name, year, onNavigate }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [videoError, setVideoError] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <main className={`main-content ${isLoaded ? 'loaded' : ''} ${videoError ? 'video-fallback' : ''}`}>
      <div className="video-scenery">
        {!videoError && (
          <video 
            autoPlay 
            loop 
            muted 
            playsInline 
            className="scenery-video"
            onError={() => setVideoError(true)}
          >
            <source src="/assets/scenery.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )}
        <div className="video-overlay"></div>
      </div>
      
      <div className="content-wrapper">
        <div className="hero-text">
          <span className="brand-label">WEB DEVELOPER</span>
          <h1 className="big-text">{name}</h1>
          <p className="subtitle">Creating digital experiences that matter</p>
        </div>
        
        <div className="hero-cta">
          <button className="cta-button" onClick={() => onNavigate('projects')}>
            View My Work
          </button>
        </div>
      </div>
    </main>
  );
};

export default MainContent; 